export const SCROLL_TO_TOP = 'SCROLL_TO_TOP';
export const RESET_SCROLL_TO_TOP = 'RESET_SCROLL_TO_TOP';
export const SCROLL_TO_DIRECTOR_MESSAGE = 'SCROLL_TO_DIRECTOR_MESSAGE';
export const RESET_SCROLL_TO_DIRECTOR_MESSAGE = 'RESET_SCROLL_TO_DIRECTOR_MESSAGE';
export const SCROLL_TO_INFORMATION = 'SCROLL_TO_INFORMATION';
export const RESET_SCROLL_TO_INFORMATION = 'RESET_SCROLL_TO_INFORMATION';
export const SCROLL_TO_PROGRAM = 'SCROLL_TO_PROGRAM';
export const RESET_SCROLL_TO_PROGRAM = 'RESET_SCROLL_TO_PROGRAM';
export const SCROLL_TO_DIRECTION = 'SCROLL_TO_DIRECTION';
export const RESET_SCROLL_TO_DIRECTION = 'RESET_SCROLL_TO_DIRECTION';
export const SCROLL_TO_OPINIONS = 'SCROLL_TO_OPINIONS';
export const RESET_SCROLL_TO_OPINIONS = 'RESET_SCROLL_TO_OPINIONS';
export const SCROLL_TO_CONTACT = 'SCROLL_TO_CONTACT';
export const RESET_SCROLL_TO_CONTACT = 'RESET_SCROLL_TO_CONTACT';
